import {z} from 'zod';

import {parseJSON} from 'shared/web';

const ServiceCaseJobDataSchema = z.object({
  name: z.string().nullish(),
  description: z.string().nullish(),
  solution: z.string().nullish(),
  positionType: z.string().nullish(),
  damageCode: z.string().nullish(),
  eskulabAuthorizationNumber: z.string().nullish(),
  eskulabStatus: z.string().nullish(),
  eskulabValidityDate: z.string().nullish(),
  eskulabValidityMileageInKm: z.number().nullish(),
  groundingReason: z.string().nullish(),
});

export const getServiceCaseJobData = (dataJson: string) => {
  const data = parseJSON(dataJson, ServiceCaseJobDataSchema);
  return data;
};
